import script from "./BlogDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogDetailView.vue?vue&type=script&setup=true&lang=js"

import "./BlogDetailView.vue?vue&type=style&index=0&id=8e5439d2&lang=css"

const __exports__ = script;

export default __exports__